export const HANDLE_LOGIN = "HANDLE_LOGIN";
export const HANDLE_SEND_OTP = "HANDLE_SEND_OTP";
export const HANDLE_SUBMIT_OTP = "HANDLE_SUBMIT_OTP";
export const HANDLE_LOGOUT = "HANDLE_LOGOUT";
export const HANDLE_CHANGE_PASSWORD = "HANDLE_CHANGE_PASSWORD";
export const HANDLE_FETCH_AMADEUS_TOKEN = "HANDLE_FETCH_AMADEUS_TOKEN";
export const FETCH_USER_PERMISSIONS = "FETCH_USER_PERMISSIONS";
